<template>
    <v-navigation-drawer
        color="white"
        @input="getthe"
        v-model="local_drawer"
        :mini-variant="mini"
        app
        class="elevation-4"
        style="height: 100svh !important"
    >
        <div class="background-nav"></div>

        <v-list-item @click.stop="mini = !mini" class="avatar-b-color">
            <v-list-item-content>
                <v-list-item-title class="text-center">
                    <img
                        style="width: 75%; margin: auto"
                        :src="'https://fidiaspro.com/wp-content/uploads/2022/03/Logo-Fidias-Pro-sin-fondo-Negro-e1646664499686.png'"
                    />
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <default-lateral ref="defaultLateral"></default-lateral>
        <div style="padding: 1rem" v-if="canSwitchProfiles">
            <v-autocomplete
                v-model="id_usuario"
                :items="usuarios"
                item-text="nombre"
                item-value="id"
                label="Cambiar Usuario"
                :disabled="!canSwitchProfiles"
            >
            </v-autocomplete>
            <small
                v-if="id_usuario != userData.id"
                class="text-warning d-block mt-2"
            >
                <v-icon small color="warning">mdi-account-switch</v-icon>
                Perfil temporal activo
            </small>
        </div>
    </v-navigation-drawer>
</template>

<script>
import defaultLateral from "./defaultLateral.vue";
import { mapGetters } from "vuex";
export default {
    props: ["drawer"],
    components: {
        defaultLateral,
    },
    data() {
        return {
            usuarios: [],
            // id_usuario: parseInt(localStorage.getItem("user_id")),
            id_usuario: null,
            // main_rol: parseInt(localStorage.getItem("real_role")),
            main_rol: null,
            lateral: "defaultLateral",
            mini: false,
            local_drawer: true,
        };
    },
    computed: {
        ...mapGetters({
            userRole: "auth/userRole",
            userData: "auth/userData", // Perfil real (usuario que ha iniciado sesion)
            userDataTemp: "auth/userDataTemp", // Perfil temporal (usuario que ha seleccionado para cambiar)
            canSwitchProfiles: "auth/canSwitchProfiles",
        }),
    },
    created() {
        this.getUsuarios();
        // Esperar a que se carguen los datos del usuario
        this.$nextTick(() => {
            // Perfil real
            if (this.userData && this.userData.id) {
                this.main_rol = this.userData.role;
            }

            // Perfil temporal
            if (this.userDataTemp && this.userDataTemp.id) {
                this.id_usuario = this.userDataTemp.id;
            } else {
                // Si no hay perfil temporal, se usa el perfil real
                this.id_usuario = this.userData.id;
            }
        });
    },
    methods: {
        getthe(e) {
            this.$emit("emitInnputDrawer", e);
        },
        getUsuarios() {
            axios.post(`api/get-usuarios-empleados`).then(
                (res) => {
                    this.usuarios = res.data.users.data;
                },
                (err) => {
                    this.$toast.error("Error consultando Fichajes");
                }
            );
        },
    },

    watch: {
        id_usuario(val) {
            if (val && this.usuarios.length > 0) {
                const usuario = this.usuarios.find(
                    (element) => element.id == val
                );

                if (usuario) {
                    let permisos = [];
                    if (usuario.permisos) {
                        usuario.permisos.forEach((permiso) => {
                            permisos.push(permiso.modulo);
                        });
                    }

                    // Llamar al endpoint para obtener el token temporal
                    axios
                        .post("api/switch-profile", { user_id: usuario.id })
                        .then((res) => {
                            const data = res.data;

                            // Cambiar a perfil temporal (solo los datos del menú, el token sigue siendo el del admin)
                            this.$store.dispatch("auth/setUserDataTemp", {
                                id: parseInt(usuario.id),
                                name: usuario.nombre,
                                email: usuario.email,
                                role: parseInt(usuario.role),
                                role_tfg: parseInt(usuario.rol_tfg),
                                permissions: permisos,
                                token: data.token,
                            });

                            // Solo almacenamos en localStorage datos no sensibles
                            localStorage.setItem("user_name", usuario.nombre);
                            localStorage.setItem("user_email", usuario.email);
                            localStorage.setItem("user_id", usuario.id);

                            this.$nextTick(() => {
                                window.location.reload();
                            });
                        })
                        .catch((err) => {
                            this.$toast.error("Error al cambiar de perfil");
                            console.error(err);
                        });
                }
            }
        },
        drawer: {
            immediate: true,
            handler: function (n) {
                this.local_drawer = n;
            },
        },
    },
};
</script>

<style media="screen">
.v-navigation-drawer .v-list .v-list-item > .v-list__tile .v-list__tile__title {
    font-size: 14px !important;
    font-weight: 100;
    padding: 0;
}

.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
    font-size: 17px !important;
    font-weight: 300;
    text-transform: capitalize;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 15px !important;
}

.v-list--dense .v-list-item .v-list-item__icon,
.v-list-item--dense .v-list-item__icon {
    opacity: 0.9;
    color: #fff;
}

.v-list--nav .v-list-item {
    padding: 8px 15px !important;
}

.v-list-item--active:before,
.v-list-item--active:hover:before,
.v-list-item:focus:before {
    /*opacity: 1*/
}

.theme--dark.v-list-item--active:before,
.theme--dark.v-list-item--active:hover:before,
.theme--dark.v-list-item:focus:before {
    /*opacity: 0;*/
}

.avatar-b-color {
    background-color: #fff !important;
}

.v-list-item--active {
    background-color: rgb(91, 198, 236) !important;
    color: white !important;
}

.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
    /*opacity: 0 !important;*/
}
</style>
